import type { ProjectAccess as ProjectPermission } from '~/lib/.server/utils/project-info';

export type { ProjectPermission };

export interface NormalizedProjectPermission {
  /**
   * Whether the user can view the project.
   */
  canView: boolean;

  /**
   * Whether the user can fork the project.
   */
  canFork: boolean;

  /**
   * Whether the user can change the visibility of the project.
   */
  canChangeVisibility: boolean;

  /**
   * Whether the user can edit the project.
   */
  canEdit: boolean;

  /**
   * Whether the user can publish the project.
   */
  canPublish: boolean;

  /**
   * Whether the user can open the project settings.
   */
  canOpenProjectSettings: boolean;

  /**
   * Whether the user can rename the project.
   */
  canRename?: boolean;
}

export function normalizePermissions(permissions: ProjectPermission | undefined): NormalizedProjectPermission {
  if (!permissions) {
    return {
      canView: false,
      canFork: false,
      canChangeVisibility: false,
      canEdit: false,
      canPublish: false,
      canOpenProjectSettings: false,
      canRename: false,
    };
  }

  const canFork = permissions.canFork;
  const canChangeVisibility = permissions.canChangeVisibility;
  const canEdit = permissions.canManage && permissions.canUploadFiles;
  const canPublish = canEdit;
  const canRename = permissions.canManage;
  const canOpenProjectSettings = permissions.currentUserIsOwner;

  return {
    canView: true,
    canFork,
    canChangeVisibility,
    canEdit,
    canPublish,
    canRename,
    canOpenProjectSettings,
  };
}
